import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { combineLatest } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FarmService } from './farm.service';
import { ThemeConfig } from '../../../assets/data/enum/themeConfig';

@Injectable()
export class YnnovaService {
  constructor(
    private farmService: FarmService,
    private http: HttpClient
  ) {}

  private themeConfig = ThemeConfig;
  private ynnovaUrl = environment.telemetryServiceUrl;
  private apiBaseUrl = environment.apiBaseUrl;

  requestOnboardingURL(arag: boolean): string {
    if (arag) {
      const companyLoggedIn = localStorage.getItem('companyLoggedIn');
      const callback = 'https://telemetry.xfarm.ag/oauth/callback/ynnova-arag';
      const location = `https://dev-51569fa7-30cf-4311-bce7-8a0059557ac2.mybravo.net/account/xfarmauth?callback=${callback}/${companyLoggedIn}`;
      return location;
    } else {
      let farmUUID = '';
      combineLatest([this.farmService.getFarmMeFromLocalStore()]).subscribe(([currentFarm]) => {
        farmUUID = currentFarm.agrirouterUUID;
      });
      const callback = 'https://telemetry.xfarm.ag/oauth/callback/ynnova';
      const location = `https://dev-369ed7de-3162-4849-a92f-f62dc077fa0a.yconnect.ag/account/xfarmsignin?callback=${callback}/${farmUUID}`;
      return location;
    }
  }

  disconnect(arag: boolean): Observable<any> {
    return this.http
      .get<any>(this.ynnovaUrl + 'api/private/v3/machine/ynnova/disconnectProvider?arag=' + arag)
      .pipe(
        map((x) => {
          return x;
        })
      );
  }

  checkConnect(arag: boolean): Observable<any> {
    return this.http
      .get<any>(this.ynnovaUrl + 'api/private/v3/machine/ynnova/isUserConnected?arag=' + arag)
      .pipe(
        map((x) => {
          return x;
        })
      );
  }

  getMachineDetails(externalId: string): Observable<any> {
    return this.http
      .get(this.ynnovaUrl + 'api/private/v3/machine/ynnova/' + externalId + '/detail')
      .pipe(map((response) => response));
  }

  sendActivityToYnnovaIsobus(fieldActivityId, externalId): Observable<any> {
    return this.http
      .post(
        this.apiBaseUrl + 'api/private/v3/isoxml/fieldActivity/' + fieldActivityId + '/send',
        null,
        {
          params: {
            externalSource: 'YNNOVA',
            equipmentId: externalId,
            devMode: this.themeConfig.isIsoTaskDevMode,
          },
        }
      )
      .pipe(map((response) => response));
  }
  sendActivityToYnnovaNonIsobus(fieldActivityId, equipmentId): Observable<any> {
    return this.http
      .post(
        this.ynnovaUrl +
          'api/private/v3/machine/ynnova/' +
          fieldActivityId +
          '/sendTask?externalSource=YNNOVA&equipmentId=' +
          equipmentId,
        null
      )
      .pipe(map((response) => response));
  }
}
